<div class="wrap">
  <div class="ask">
    <div class="img">
      <img src="assets/img/icon-blue/license.svg" alt="">
      <h3>Votre licence</h3>
    </div>
    <p>Souhaitez-vous lier votre compte avec votre licence ?</p>
    <div class="btn_action">
      <button class="no" [routerLink]="['/home']" routerLinkActive="router-link-active" (click)="no()">Plus
        tard</button>
      <button (click)="nextStep()">Oui</button>
    </div>
  </div>
</div>